import React from 'react';
import PropTypes from 'prop-types';
import SoftBadge from 'components/common/SoftBadge';

const StatusRenderer = (props) => {
  const value = props.value;

  return (
    <SoftBadge pill bg={`${value === "Done" ? 'success' : 'primary'}`}>{value}</SoftBadge>
  );
};

StatusRenderer.propTypes = {
  value: PropTypes.string
};

export default StatusRenderer;
